/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

import React from 'react';
import { BlocDemandesDemat } from '@mairistem/administres-utils';
import { Dimmer } from '@mairistem/composants';

import { useResizer } from '@/hooks';
import {
  useEntiteStore,
  useProduitDomaineStore,
  useHubeeStore,
} from '@/zustand';
import HubeeStatusMessage from '@/components/Hubee/HubeeStatusMessage';

import {
  BlocCreationRecense,
  BlocGestionTrimestre,
  BlocStatistiques,
  // BlocDemandesDemat,
} from './Blocs';
import VueSynthetique from './Blocs/VueSynthetique';

const Dashboard = () => {
  const [width, setWidth] = React.useState(window.innerWidth);
  const [, setLoadingStatistiqueTableau] = React.useState<boolean>(false);
  const [, setLoadingStatistiqueGraphique] = React.useState<boolean>(false);
  const [, setLoadingSynthetique] = React.useState<boolean>(false);
  const produitDomaine = useProduitDomaineStore(
    (state) => state.produitDomaine,
  );
  const entite = useEntiteStore((state) => state.selectedEntite);
  const hubeeStatus = useHubeeStore((state) => state.hubeeStatus);

  useResizer(width, setWidth);

  const renderMobileScreen = React.useMemo(
    () => (
      <div
        style={{
          height: '100%',
          overflowY: 'auto',
          padding: '1em',
          gap: '1em',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <BlocCreationRecense style={{ margin: 0 }} />
        <div style={{ position: 'relative', height: 200 }}>
          <BlocDemandesDemat
            route="/api/administres/recensement-citoyen/hubee"
            urlListe={
              _.includes(window.location.href, '360.')
                ? '/administres/recensement-citoyen/hubee'
                : '/hubee'
            }
            dataLoaded={
              !_.isNil(produitDomaine) &&
              !_.isNil(entite) &&
              !_.isNil(hubeeStatus) &&
              hubeeStatus.serialized &&
              hubeeStatus.liaisonActive
            }
            attestation
          />
          {!_.isNil(hubeeStatus) &&
            (!hubeeStatus.serialized || !hubeeStatus.liaisonActive) && (
              <Dimmer active inverted style={{ borderRadius: 16 }}>
                <div style={{ textAlign: 'center' }}>
                  <HubeeStatusMessage
                    serialized={hubeeStatus.serialized}
                    liaisonActive={hubeeStatus.liaisonActive}
                  />
                </div>
              </Dimmer>
            )}
        </div>
        <VueSynthetique
          setLoading={setLoadingSynthetique}
          style={{ margin: 0 }}
        />
        <BlocStatistiques
          setLoadingTab={setLoadingStatistiqueTableau}
          setLoadingGraph={setLoadingStatistiqueGraphique}
          style={{ margin: 0 }}
        />
        <BlocGestionTrimestre style={{ margin: 0 }} />
      </div>
    ),
    [produitDomaine, entite, hubeeStatus],
  );

  const renderDesktopScreen = React.useMemo(
    () => (
      <div
        style={{
          height: '100%',
          display: 'flex',
          gap: '1em',
          padding: '1em',
          overflowY: 'auto',
        }}
      >
        <div
          style={{
            flex: 6,
            display: 'flex',
            flexDirection: 'column',
            gap: '1em',
          }}
        >
          {/* <button onClick={() => { throw new Error('Test Sentry'); }}
         type="button">Test Sentry</button> */}
          <BlocCreationRecense
            style={{ minHeight: 200, maxHeight: 200, margin: 0 }}
          />
          <BlocGestionTrimestre style={{ margin: 0 }} />
        </div>
        <div
          style={{
            flex: 10,
            display: 'flex',
            flexDirection: 'column',
            gap: '1em',
          }}
        >
          <VueSynthetique
            setLoading={setLoadingSynthetique}
            style={{ minHeight: 200, maxHeight: 200, margin: 0 }}
          />
          <BlocStatistiques
            style={{ margin: 0 }}
            setLoadingTab={setLoadingStatistiqueTableau}
            setLoadingGraph={setLoadingStatistiqueGraphique}
          />
          <div style={{ height: 200, position: 'relative' }}>
            <BlocDemandesDemat
              route="/api/administres/recensement-citoyen/hubee"
              urlListe={
                _.includes(window.location.href, '360.')
                  ? '/administres/recensement-citoyen/hubee'
                  : '/hubee'
              }
              dataLoaded={
                !_.isNil(produitDomaine) &&
                !_.isNil(entite) &&
                !_.isNil(hubeeStatus) &&
                hubeeStatus.serialized &&
                hubeeStatus.liaisonActive
              }
              attestation
            />
            {!_.isNil(hubeeStatus) &&
              (!hubeeStatus.serialized || !hubeeStatus.liaisonActive) && (
                <Dimmer active inverted style={{ borderRadius: 16 }}>
                  <div style={{ textAlign: 'center' }}>
                    <HubeeStatusMessage
                      serialized={hubeeStatus.serialized}
                      liaisonActive={hubeeStatus.liaisonActive}
                    />
                  </div>
                </Dimmer>
              )}
          </div>
        </div>
      </div>
    ),
    [produitDomaine, entite, hubeeStatus],
  );
  if (width < 1200) return renderMobileScreen;

  return renderDesktopScreen;
};

export default Dashboard;
